import { FilledInput, FormControl, FormHelperText, InputLabel, styled } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { DateTimeRangePicker } from "@mui/x-date-pickers-pro/DateTimeRangePicker";
import { motion } from "motion/react";
import { ReactNode } from "react";

export const CommonInput = styled(FilledInput)(() => ({
    "label + &": {
        marginTop: 20,
    },
    "& .MuiInputBase-input": {
        paddingBottom: 12,
        paddingTop: 12,
    },
    "& MuiInputBase-root": {
        padding: 0,
    },
    "&": {
        width: "100%",
    },
    "&.Mui-error": {
        ["& .MuiInputAdornment-root"]: {
            color: "#f45f5f !important",
        },
    },
}));

export const CommonHelperText = ({ text }: { text: string }) => {
    return text ? (
        <FormHelperText className="!mt-[3px] !mx-[14px] -translate-y-5" error>
            {text}
        </FormHelperText>
    ) : null;
};

const MotionFormControl = motion(FormControl);

export function CommonLabel({
    label,
    children,
    className,
    description,
    required,
    labelClass,
}: {
    description?: string;
    label: string;
    children: ReactNode;
    className: string;
    required?: boolean;
    labelClass?: string;
}) {
    return (
        <MotionFormControl
            animate={{
                y: 0,
                opacity: 1,
            }}
            initial={{
                y: 50,
                opacity: 0,
            }}
            exit={{
                opacity: 0,
                scale: 0,
            }}
            variant="standard"
            className={className + "  !space-y-5"}
        >
            <InputLabel
                shrink
                htmlFor="bootstrap-input"
                className={"!pb-5   pl-1 !font-semibold !text-gray-800  " + (labelClass || "")}
            >
                <div className=" mb-4 !pb-4">
                    {label} {description && <span className=" text-gray-500 text-sm">({description})</span>}{" "}
                    {required && <span className="text-blue-600   ml-auto">*</span>}
                </div>
            </InputLabel>
            {children}
        </MotionFormControl>
    );
}

export const CommonDatePicker = styled(DateTimeRangePicker)(() => ({
    "& .MuiInputBase-root": {
        backgroundColor: "rgba(0, 0, 0, 0.06)",
        border: "0px solid transparent",
        outline: "none",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.09)",
        },
        "&.Mui-focused": {
            backgroundColor: "rgba(0, 0, 0, 0.12)",
        },
    },

    "& .MuiInputBase-input": {
        paddingBottom: 12,
        paddingTop: 12,
    },
}));

export const CommonDatePickerPlain = styled(DateTimePicker)(() => ({
    "& .MuiInputBase-root": {
        backgroundColor: "rgba(0, 0, 0, 0.06)",
        border: "0px solid transparent",
        outline: "none",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.09)",
        },
        "&.Mui-focused": {
            backgroundColor: "rgba(0, 0, 0, 0.12)",
        },
    },

    "& .MuiInputBase-input": {
        paddingBottom: 12,
        paddingTop: 12,
    },
}));
